import { render } from "./MyAddressView.vue?vue&type=template&id=9715ff66&ts=true"
import script from "./MyAddressView.vue?vue&type=script&lang=ts"
export * from "./MyAddressView.vue?vue&type=script&lang=ts"

import "./MyAddressView.vue?vue&type=style&index=0&id=9715ff66&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__